import ModifyCard from "../../subscription/view/payment/modifyCard";
import { FSLoader, Modal, Result, Text } from "../../../components";
import Localization from "../../../localization";
import { Constants } from "../../../utils";
import styled from "styled-components";
import { Col, Row } from "antd";
import React from "react";
import Item from "./item";

const View = ({
  refs,
  plans = [],
  loading = false,
  checkout = () => {},
  addSubscriptionPaymentCard = () => {},
}) => {
  if (loading) return <FSLoader />;
  if (!plans.length)
    return (
      <Result
        status="404"
        title={Localization.not_found.title}
        subTitle={Localization.not_found.desc}
      />
    );
  return (
    <Styled className="p-50-h p-50-t p-100-b">
      <Text
        weight={700}
        lineHeight="normal"
        className="m-30-b main-title"
        children={Localization.subscription_plans.title}
      />
      <Row
        gutter={[16, 16]}
        children={React.Children.toArray(
          plans.map((plan) => (
            <Col xs={24} sm={24} md={24 / 2} lg={24 / 3}>
              <Item {...plan} onSelect={() => checkout(plan)} />
            </Col>
          ))
        )}
      />
      <Modal
        ref={refs.modifyCard}
        title={Localization.general.update_payment_card}
        child={({ plan }) => (
          <ModifyCard
            showInvoiceNote={false}
            onDone={() => addSubscriptionPaymentCard(plan)}
            onCancel={() => refs.modifyCard.current.close()}
          />
        )}
      />
    </Styled>
  );
};

const Styled = styled.div`
  background: white;
  ${(_) => _.theme.mobile(`padding: 3rem  2rem 2rem !important;`)}
  .main-title {
    font-size: 4.8rem;
    ${(_) => _.theme.mobile(`font-size: 3rem; margin-bottom: 2rem !important;`)}
  }
`;

export default View;
